import { TextBlockElementModel } from '@/services/platform/api/model';
import ModuleWrapper from '../../shared/module/wrapper';
import { cn, ModuleProperties } from '@/lib/core';
import { Heading } from '../../ui/heading';
import { Icon } from '../../ui/icon';
import './style.scss';

export const TextBlock = (props: ModuleProperties) => {
  const content = props.content as TextBlockElementModel | undefined;

  if (!content) return null;

  return (
    <ModuleWrapper
      component={props}
      classNames={{
        base: cn(['module__text-block']),
      }}
      isFullWidth={true}
      {...props}
    >
      <div key={props.index} className="col-span-2 lg:col-span-12">
        <div className="rounded-lg border p-4 shadow-sm">
          <div className="flex items-center gap-2">
            <Icon name="check-circle-solid" width={24} height={24} className="text-green-600" />
            <Heading
              as={'h3' as React.ElementType}
              className={cn('font-didot my-2 text-[36px] font-semibold italic')}
            >
              {content?.contentType}
            </Heading>
          </div>
          <div className="flex items-center gap-2">
            <Icon name="info-circle-solid" width={24} height={24} className="text-blue-600" />
            <Heading
              as={'h3' as React.ElementType}
              className={cn('font-pp-neue-montreal my-2 text-[36px] font-semibold')}
            >
              {content?.contentType}
            </Heading>
          </div>
          <pre className="overflow-x-auto text-sm text-gray-700">{JSON.stringify(content, null, 2)}</pre>
        </div>
      </div>
    </ModuleWrapper>
  );
};
